<template>
 
 <div v-if="localQuizData" class="quiz " style="background: #fff; position: relative; border-radius: 8px; text-align: left; overflow: hidden; display: block;">
    <div class="quiz-header pixelsbg" style="padding: 20px;">
        <a 

style="
  position: absolute; 
  top: -5px; 
  right: 10px; 
  font-size: 2.25rem; 
  font-weight: 300; 
  color: #9CB3BD; 
  transition: transform 0.2s ease-in-out;
  color: #fff;
  cursor: pointer;
" 
@click="closeQuizLightbox()"
>×</a>



        <h3 style="color: #fff;">{{ localQuizData.Title }} {{ isQuizCompleted ? " Review" : null }}</h3>
     
        <p style="margin-bottom: 0; color: #fff; font-style: italic; font-weight: 300;"><small>Question {{ currentQuestion + 1 }} of {{ localQuizData && localQuizData.Questions ? localQuizData.Questions.length : null }}</small></p>
    
      </div>
      
        <div v-if="localQuizData?.Questions?.[currentQuestion]" style="padding: 20px;">
         
            
      

  

      <div v-if="quizStep === 'questions' && localQuizData">

       
        
       
        <h5 style="color: #4d5967; margin-bottom: 20px;">
          {{ localQuizData?.Questions?.[currentQuestion]?.Question || '' }}
        </h5>
        <hr/>
  
        

     

        <div class="options" style="margin-bottom: 60px;">
  <label class="custom-radio">
    <input type="radio" value="OptionA" v-model="selectedAnswers[currentQuestion]">
    <span class="checkmark"></span>
    <span>{{ localQuizData.Questions[currentQuestion].OptionA }}</span>
  </label>
  <label class="custom-radio">
    <input type="radio" value="OptionB" v-model="selectedAnswers[currentQuestion]">
    <span class="checkmark"></span>
    <span>{{ localQuizData.Questions[currentQuestion].OptionB }}</span>
  </label>
  <label class="custom-radio">
    <input type="radio" value="OptionC" v-model="selectedAnswers[currentQuestion]">
    <span class="checkmark"></span>
    <span>{{ localQuizData.Questions[currentQuestion].OptionC }}</span>
  </label>
  <label class="custom-radio">
    <input type="radio" value="OptionD" v-model="selectedAnswers[currentQuestion]">
    <span class="checkmark"></span>
    <span>{{ localQuizData.Questions[currentQuestion].OptionD }}</span>
  </label>
</div>

   
    
  

        <div class="navigation" style="display: flex">
          <button 
          @click="prevQuestion" 
          :disabled="currentQuestion === 0"
          class="mb0 lh1 mrauto dib d-flex center list-btn"
          style="margin-right: auto;"
          ><i class="material-icons">keyboard_arrow_left</i> Previous</button>
          <button v-if="currentQuestion < localQuizData.Questions.length - 1" 
                  @click="nextQuestion" 
                  class="mb0 lh1 dib d-flex center list-btn"
                  :disabled="!hasAnswered(currentQuestion)"
                  style="margin-left: auto!important;">Next <i class="material-icons">keyboard_arrow_right</i></button>
          <button v-else @click="goToSubmit" class="mb0 lh1 mlauto list-btn dib d-flex center router-link-active" :disabled="!hasAnswered(currentQuestion)">Submit <i class="material-icons">keyboard_arrow_right</i></button>
        </div>
    
      </div>
  

      <div v-if="quizStep === 'submit'">
        
        <h5 style="margin-bottom: 200px;">Are you sure you want to submit your answers?</h5>
        <div style="display: flex;">
            <button @click="quizStep = 'questions'" class="mb0 lh1 mrauto dib d-flex center list-btn"><i class="material-icons">keyboard_arrow_left</i> Back to Questions</button>
            <button @click="submitQuiz" class="mb0 lh1 mlauto dib d-flex center list-btn">Yes, Submit <i class="material-icons">keyboard_arrow_right</i></button>
            
        </div>
      </div>
  
    
      <div v-if="quizStep === 'results'">
        <h5>Quiz Results:</h5>
        <hr/>
  
        <div v-for="(result, index) in quizResults" :key="'result' + index">
  <p :class="{ 'incorrect-answer': !result.isCorrect }"><b>Question {{ index + 1 }}: </b>
    <strong :class="{ 'correct-answer': result.isCorrect, 'incorrect-answer': !result.isCorrect }">{{ result.isCorrect ? 'Correct' : 'Incorrect' }}</strong>
    
   
    <span v-if="result.isCorrect" class="correctmark">✔</span>
    <span v-else class="xmark">x</span>
  </p>


  <p v-if="!result.isCorrect"><b>Correct Answer:</b> <span style="font-weight: 300;">{{ result.correctAnswer }}</span></p>
</div>

        <hr/>

        <div v-if="incorrectCount <= 1">
          <p>{{ randomSuccessMessage }}</p>
        </div>
        <div v-else>
          <p style="font-weight: 300;">You've got {{ incorrectCount }} incorrect answers. Would you like to retake the quiz?</p>
          <button @click="retakeQuiz" class="mb0 lh1 mrauto dib d-flex center list-btn"><i class="material-icons">keyboard_arrow_left</i> Retake Quiz</button>
        </div>
  
       
      </div>
    
    </div>
</div>
</template>
  
  
  
  <script>
  import axios from 'axios';
  export default {
    name: "Quiz",
    
    props: {
  
  quizData: {
    type: Object,
    required: true
  },
  ModuleID: {
    type: Number,
    required: true
  },
  closeQuizLightbox: {
    type: Function,
    required: true
  },
  loadNewContent: {
    type: Function,
    required: true
  },
  completeQuiz: {
    type: Function,
    required: true
  },
},

    data() {
      return {
        localQuizData: { 
          Questions: [],
          Title: null,
          QuizID: null,
          Published: null
        },        
        currentQuestion: 0, // Tracks the current question index
        selectedAnswers: {}, // Stores the user's selected answers
        quizStep: 'questions', // Tracks the current step (questions, submit, results)
        quizResults: [],       // Stores the results after submission
        incorrectCount: 0,     // Tracks the number of incorrect answers
        randomSuccessMessage: '' // Store a random success message
      };
      
    },
    mounted() {
        console.log('Quiz data received:', this.quizData);
        
            this.localQuizData = this.quizData; // Set local data
    
        
        console.log('Local quiz data initialized:', this.localQuizData);
    },
    methods: {
      nextQuestion() {
        // Move to the next question
        if (this.currentQuestion < this.localQuizData.Questions.length - 1) {
          this.currentQuestion++;
        }
      },
      prevQuestion() {
        // Move to the previous question
        if (this.currentQuestion > 0) {
          this.currentQuestion--;
        }
      },
      goToSubmit() {
        // Go to submit confirmation step
        this.quizStep = 'submit';
      },
      submitQuiz() {
        // Submit the quiz and check answers, then move to results step
        this.quizStep = 'results';
        let incorrectAnswers = 0;
  
        this.quizResults = this.localQuizData.Questions.map((question, index) => {
          const correctAnswer = Object.keys(question).find(key => question[key] === question.CorrectAnswer);
          const isCorrect = question[correctAnswer] === question[this.selectedAnswers[index]];
  
          if (!isCorrect) {
            incorrectAnswers++;
          }
  
          return {
            question: question.Question,
            isCorrect,
            correctAnswer: question.CorrectAnswer
          };
        });
  
        this.incorrectCount = incorrectAnswers;
  
        // If all answers are correct or only one is incorrect, display a success message
        if (this.incorrectCount <= 1) {
          this.randomSuccessMessage = this.getRandomSuccessMessage();
          this.sendPostRequest();
        }
      },
      hasAnswered(questionIndex) {
        // Check if the user has answered the current question
        return this.selectedAnswers[questionIndex] !== undefined;
      },
      getRandomSuccessMessage() {
        // List of success messages
        const successMessages = [
          "Great job! You're a star!",
          "Fantastic! You nailed it!",
          "Awesome! You're amazing!",
          "Excellent! You got it right!",
          "Impressive work!",
          "Well done! Keep it up!",
          "You crushed it!",
          "Brilliant performance!",
          "Amazing job!",
          "Outstanding! Keep shining!",
          "You're on fire! 🔥",
          "Spot on! Genius move!",
          "Nailed it like a pro!",
          "Superb! You're killing it!",
          "Yes! That's the way!",
          "Wow — you’re crushing this quiz!",
          "You’re making this look easy!",
          "High-five through the screen! ✋",
          "That’s some next-level smarts!",
          "Quiz? More like your playground!",
        ];
  
        // Return a random message
        return successMessages[Math.floor(Math.random() * successMessages.length)];
      },
      retakeQuiz() {
        // Reset quiz to start over
        this.currentQuestion = 0;
        this.selectedAnswers = {};
        this.quizStep = 'questions';
      },
      sendPostRequest() {
        if(!this.isQuizCompleted){
          // alert("new attempt");
          this.completeQuiz();
       } else{
        // alert("already completed");
        return;
       }
      }, 
    },
    computed: {
      isQuizCompleted() {
        return this.quizData.complete;
      }
    }
};
</script>
  
  

  
<style scoped>
.question {
  margin-bottom: 20px;
}
.options label {
  display: block;
  margin-bottom: 10px;
}
button:disabled {
    opacity: 0.2!important;
    cursor: unset !important;
    border: 2px solid #4d596733!important;
    background: #4d5967;
}

.quiz{
    border-radius: 4px;
}



.custom-radio {
    position: relative;
    display: inline-block;
    padding-left: 30px;
    margin-right: 10px;
    cursor: pointer;
    line-height: 1.5;
  }

  .custom-radio input[type="radio"] {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  .checkmark {
    position: absolute;
    top: 4px;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #eee;
    border-radius: 50%;
  }

  .custom-radio input:checked ~ .checkmark {
    background-color: #519bb2;
  }

  /* Create the radio button indicator */
  .checkmark::after {
    content: "";
    position: absolute;
    display: none;
  }

  .custom-radio input:checked ~ .checkmark::after {
    display: block;
  }

  /* Style the indicator (dot inside the radio button) */
  .custom-radio .checkmark::after {
    top: 5px;
    left: 5px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: white;
  }

  .correct-answer {
   /* Default color for correct answers */
   font-weight: 300;
  }

  .incorrect-answer {
    /* Default color for incorrect answers */
    font-weight: 300;
  }

  .correctmark {
    color: #429da8;
    margin-left: 10px;
  }

  .xmark {
    color: #f16232;
    margin-left: 10px;
  }

  /* You can adjust the size of the checkmark if needed */
  .correctmark, .xmark {
    font-size: 20px;
  }

  @media all and (min-width: 991px) {
    .quiz{
        max-width: 700px;
        border-radius: 4px;
        min-width: 700px;
    }
	
  }

  .pixelsbg {
  background-color: #475059;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23586470'/%3E%3Cstop offset='1' stop-color='%23586470' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23505a65'/%3E%3Cstop offset='1' stop-color='%23505a65' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%233f474f'/%3E%3Cstop offset='1' stop-color='%233f474f' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23697887'/%3E%3Cstop offset='1' stop-color='%23697887' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23383e45'/%3E%3Cstop offset='1' stop-color='%23383e45' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='%23474f58' x='149' y='-1' width='152' height='152'/%3E%3Crect fill='%23464f58' x='299' y='149' width='152' height='152'/%3E%3Crect fill='%23464e57' x='300' y='-1' width='151' height='151'/%3E%3Crect fill='%23454e56' x='449' y='299' width='152' height='152'/%3E%3Crect fill='%23454d56' x='450' y='149' width='151' height='151'/%3E%3Crect fill='%23444d55' x='450' y='-1' width='151' height='151'/%3E%3Crect fill='%23444c55' x='600' y='299' width='151' height='152'/%3E%3Crect fill='%23434b54' x='600' y='149' width='151' height='151'/%3E%3Crect fill='%23434b53' x='600' y='-1' width='151' height='151'/%3E%3Crect fill='%23424a53' x='749' y='449' width='152' height='152'/%3E%3Crect fill='%23424a52' x='750' y='299' width='151' height='151'/%3E%3Crect fill='%23414951' x='750' y='149' width='151' height='151'/%3E%3Crect fill='%23414951' x='750' y='-1' width='151' height='151'/%3E%3Crect fill='%23404850' x='899' y='599' width='152' height='152'/%3E%3Crect fill='%23404750' x='900' y='449' width='151' height='151'/%3E%3Crect fill='%233f474f' x='900' y='299' width='151' height='151'/%3E%3Crect fill='%233f464e' x='900' y='149' width='151' height='151'/%3E%3Crect fill='%233f464e' x='900' y='-1' width='151' height='151'/%3E%3Crect fill='%233e454d' x='1050' y='449' width='151' height='152'/%3E%3Crect fill='%233e454c' x='1050' y='299' width='151' height='151'/%3E%3Crect fill='%233d444c' x='1050' y='149' width='151' height='151'/%3E%3Crect fill='%233d444b' x='1050' y='-1' width='151' height='151'/%3E%3Crect fill='%233c434b' x='1200' y='299' width='151' height='152'/%3E%3Crect fill='%233c424a' x='1200' y='149' width='151' height='151'/%3E%3Crect fill='%233b4249' x='1200' y='-1' width='151' height='151'/%3E%3Crect fill='%233b4149' x='1350' y='299' width='151' height='152'/%3E%3Crect fill='%233a4148' x='1350' y='149' width='151' height='151'/%3E%3Crect fill='%233a4047' x='1350' y='-1' width='151' height='151'/%3E%3Crect fill='%23394047' x='1500' y='149' width='151' height='152'/%3E%3Crect fill='%23393f46' x='1500' y='-1' width='151' height='151'/%3E%3Crect fill='%23383f46' x='1650' y='-1' width='151' height='152'/%3E%3Crect fill='%23394047' x='1800' y='149' width='152' height='152'/%3E%3Crect fill='%233b4148' x='1649' y='150' width='152' height='151'/%3E%3Crect fill='%233c434a' x='1800' y='300' width='152' height='151'/%3E%3Crect fill='%233d444c' x='1649' y='300' width='152' height='151'/%3E%3Crect fill='%233f464e' x='1800' y='450' width='152' height='151'/%3E%3Crect fill='%2340474f' x='1800' y='600' width='152' height='151'/%3E%3Crect fill='%23414951' x='1649' y='450' width='152' height='151'/%3E%3Crect fill='%23434a53' x='1499' y='300' width='151' height='151'/%3E%3Crect fill='%23444c55' x='1800' y='750' width='152' height='151'/%3E%3Crect fill='%23454d57' x='1649' y='600' width='152' height='151'/%3E%3Crect fill='%23474f58' x='1499' y='450' width='151' height='151'/%3E%3Crect fill='%2348515a' x='1800' y='900' width='152' height='151'/%3E%3Crect fill='%2349525c' x='1649' y='750' width='152' height='151'/%3E%3Crect fill='%234b545e' x='1499' y='600' width='151' height='151'/%3E%3Crect fill='%234c5560' x='1349' y='450' width='151' height='151'/%3E%3Crect fill='%234d5761' x='1800' y='1049' width='152' height='151'/%3E%3Crect fill='%234f5963' x='1649' y='900' width='152' height='151'/%3E%3Crect fill='%23505a65' x='1499' y='750' width='151' height='151'/%3E%3Crect fill='%23515c67' x='1349' y='600' width='151' height='151'/%3E%3Crect fill='%23535d69' x='1199' y='450' width='151' height='151'/%3E%3Crect fill='%23545f6b' x='1649' y='1050' width='152' height='151'/%3E%3Crect fill='%2355616c' x='1499' y='1049' width='151' height='152'/%3E%3Crect fill='%2357626e' x='1499' y='900' width='151' height='150'/%3E%3Crect fill='%23586470' x='1349' y='1049' width='151' height='152'/%3E%3Crect fill='%235a6672' x='1349' y='899' width='151' height='151'/%3E%3Crect fill='%235b6774' x='1349' y='750' width='151' height='150'/%3E%3Crect fill='%235c6976' x='1199' y='1049' width='151' height='152'/%3E%3Crect fill='%235e6b78' x='1199' y='899' width='151' height='151'/%3E%3Crect fill='%235f6c7a' x='1199' y='749' width='151' height='151'/%3E%3Crect fill='%23616e7c' x='1199' y='600' width='151' height='150'/%3E%3Crect fill='%2362707d' x='1049' y='1049' width='151' height='152'/%3E%3Crect fill='%2363717f' x='1049' y='899' width='151' height='151'/%3E%3Crect fill='%23657381' x='1049' y='749' width='151' height='151'/%3E%3Crect fill='%23667583' x='1049' y='600' width='151' height='150'/%3E%3Crect fill='%23687685' x='899' y='899' width='151' height='152'/%3E%3Crect fill='%2348515a' x='-1' y='149' width='152' height='152'/%3E%3Crect fill='%2349525b' x='150' y='150' width='150' height='151'/%3E%3Crect fill='%234a535d' x='-1' y='300' width='152' height='151'/%3E%3Crect fill='%234b545e' x='150' y='300' width='151' height='151'/%3E%3Crect fill='%234c555f' x='-1' y='450' width='152' height='151'/%3E%3Crect fill='%234d5660' x='-1' y='600' width='152' height='151'/%3E%3Crect fill='%234d5862' x='150' y='450' width='151' height='151'/%3E%3Crect fill='%234e5963' x='300' y='300' width='150' height='151'/%3E%3Crect fill='%234f5a64' x='-1' y='750' width='152' height='151'/%3E%3Crect fill='%23505b65' x='150' y='600' width='151' height='151'/%3E%3Crect fill='%23515c67' x='300' y='450' width='151' height='151'/%3E%3Crect fill='%23525d68' x='-1' y='900' width='152' height='151'/%3E%3Crect fill='%23535e69' x='150' y='750' width='151' height='151'/%3E%3Crect fill='%23545f6a' x='300' y='600' width='151' height='151'/%3E%3Crect fill='%2355606c' x='450' y='450' width='151' height='151'/%3E%3Crect fill='%2356616d' x='-1' y='1050' width='152' height='151'/%3E%3Crect fill='%2357636e' x='150' y='900' width='151' height='151'/%3E%3Crect fill='%23586470' x='300' y='750' width='151' height='151'/%3E%3Crect fill='%23596571' x='450' y='600' width='151' height='151'/%3E%3Crect fill='%235a6672' x='600' y='450' width='150' height='151'/%3E%3Crect fill='%235b6773' x='150' y='1050' width='151' height='151'/%3E%3Crect fill='%235c6875' x='300' y='1049' width='151' height='152'/%3E%3Crect fill='%235c6976' x='300' y='900' width='151' height='150'/%3E%3Crect fill='%235d6a77' x='450' y='1049' width='151' height='152'/%3E%3Crect fill='%235e6b79' x='450' y='899' width='152' height='151'/%3E%3Crect fill='%235f6d7a' x='450' y='750' width='152' height='150'/%3E%3Crect fill='%23606e7b' x='600' y='1049' width='151' height='152'/%3E%3Crect fill='%23616f7c' x='600' y='899' width='151' height='151'/%3E%3Crect fill='%2362707e' x='600' y='749' width='151' height='151'/%3E%3Crect fill='%2363717f' x='600' y='600' width='151' height='150'/%3E%3Crect fill='%23647280' x='750' y='1049' width='151' height='152'/%3E%3Crect fill='%23657382' x='750' y='899' width='150' height='151'/%3E%3Crect fill='%23667583' x='750' y='749' width='151' height='151'/%3E%3Crect fill='%23677684' x='750' y='600' width='150' height='150'/%3E%3Crect fill='%23687786' x='900' y='1050' width='150' height='151'/%3E%3Crect fill='%23475059' x='-1' y='-1' width='151' height='151'/%3E%3Crect fill='%23697887' x='900' y='750' width='150' height='150'/%3E%3Crect fill='%23383e45' x='1800' y='-1' width='151' height='151'/%3E%3Cg fill-opacity='.5'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
  background-color: #475059;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23586470'/%3E%3Cstop offset='1' stop-color='%23586470' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%233c768a'/%3E%3Cstop offset='1' stop-color='%233c768a' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23305e6e'/%3E%3Cstop offset='1' stop-color='%23305e6e' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23697887'/%3E%3Cstop offset='1' stop-color='%23697887' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%231a8182'/%3E%3Cstop offset='1' stop-color='%231a8182' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='%2346505a' x='149' y='-1' width='152' height='152'/%3E%3Crect fill='%2344515c' x='299' y='149' width='152' height='152'/%3E%3Crect fill='%2343515d' x='300' y='-1' width='151' height='151'/%3E%3Crect fill='%2341525e' x='449' y='299' width='152' height='152'/%3E%3Crect fill='%23405260' x='450' y='149' width='151' height='151'/%3E%3Crect fill='%233e5361' x='450' y='-1' width='151' height='151'/%3E%3Crect fill='%233d5462' x='600' y='299' width='151' height='152'/%3E%3Crect fill='%233c5463' x='600' y='149' width='151' height='151'/%3E%3Crect fill='%233a5565' x='600' y='-1' width='151' height='151'/%3E%3Crect fill='%23395666' x='749' y='449' width='152' height='152'/%3E%3Crect fill='%23375767' x='750' y='299' width='151' height='151'/%3E%3Crect fill='%23365969' x='750' y='149' width='151' height='151'/%3E%3Crect fill='%23345a6a' x='750' y='-1' width='151' height='151'/%3E%3Crect fill='%23335b6b' x='899' y='599' width='152' height='152'/%3E%3Crect fill='%23325d6c' x='900' y='449' width='151' height='151'/%3E%3Crect fill='%23305e6e' x='900' y='299' width='151' height='151'/%3E%3Crect fill='%232f606f' x='900' y='149' width='151' height='151'/%3E%3Crect fill='%232d6170' x='900' y='-1' width='151' height='151'/%3E%3Crect fill='%232c6372' x='1050' y='449' width='151' height='152'/%3E%3Crect fill='%232b6573' x='1050' y='299' width='151' height='151'/%3E%3Crect fill='%23296774' x='1050' y='149' width='151' height='151'/%3E%3Crect fill='%23286975' x='1050' y='-1' width='151' height='151'/%3E%3Crect fill='%23266b77' x='1200' y='299' width='151' height='152'/%3E%3Crect fill='%23256d78' x='1200' y='149' width='151' height='151'/%3E%3Crect fill='%23246f79' x='1200' y='-1' width='151' height='151'/%3E%3Crect fill='%2322727a' x='1350' y='299' width='151' height='152'/%3E%3Crect fill='%2321747c' x='1350' y='149' width='151' height='151'/%3E%3Crect fill='%2320767d' x='1350' y='-1' width='151' height='151'/%3E%3Crect fill='%231e797e' x='1500' y='149' width='151' height='152'/%3E%3Crect fill='%231d7c80' x='1500' y='-1' width='151' height='151'/%3E%3Crect fill='%231b7e81' x='1650' y='-1' width='151' height='152'/%3E%3Crect fill='%231c8083' x='1800' y='149' width='152' height='152'/%3E%3Crect fill='%231d8083' x='1649' y='150' width='152' height='151'/%3E%3Crect fill='%231f7f84' x='1800' y='300' width='152' height='151'/%3E%3Crect fill='%23217e85' x='1649' y='300' width='152' height='151'/%3E%3Crect fill='%23227e85' x='1800' y='450' width='152' height='151'/%3E%3Crect fill='%23247d86' x='1800' y='600' width='152' height='151'/%3E%3Crect fill='%23267c87' x='1649' y='450' width='152' height='151'/%3E%3Crect fill='%23287c87' x='1499' y='300' width='151' height='151'/%3E%3Crect fill='%23297b88' x='1800' y='750' width='152' height='151'/%3E%3Crect fill='%232b7a88' x='1649' y='600' width='152' height='151'/%3E%3Crect fill='%232d7a88' x='1499' y='450' width='151' height='151'/%3E%3Crect fill='%232f7989' x='1800' y='900' width='152' height='151'/%3E%3Crect fill='%23317989' x='1649' y='750' width='152' height='151'/%3E%3Crect fill='%23337889' x='1499' y='600' width='151' height='151'/%3E%3Crect fill='%2335788a' x='1349' y='450' width='151' height='151'/%3E%3Crect fill='%2337778a' x='1800' y='1049' width='152' height='151'/%3E%3Crect fill='%233a778a' x='1649' y='900' width='152' height='151'/%3E%3Crect fill='%233c768a' x='1499' y='750' width='151' height='151'/%3E%3Crect fill='%233e768a' x='1349' y='600' width='151' height='151'/%3E%3Crect fill='%2340758a' x='1199' y='450' width='151' height='151'/%3E%3Crect fill='%2343758a' x='1649' y='1050' width='152' height='151'/%3E%3Crect fill='%2345758a' x='1499' y='1049' width='151' height='152'/%3E%3Crect fill='%2347758a' x='1499' y='900' width='151' height='150'/%3E%3Crect fill='%234a758a' x='1349' y='1049' width='151' height='152'/%3E%3Crect fill='%234c748a' x='1349' y='899' width='151' height='151'/%3E%3Crect fill='%234e748a' x='1349' y='750' width='151' height='150'/%3E%3Crect fill='%2351748a' x='1199' y='1049' width='151' height='152'/%3E%3Crect fill='%2354758a' x='1199' y='899' width='151' height='151'/%3E%3Crect fill='%2356758a' x='1199' y='749' width='151' height='151'/%3E%3Crect fill='%23597589' x='1199' y='600' width='151' height='150'/%3E%3Crect fill='%235b7589' x='1049' y='1049' width='151' height='152'/%3E%3Crect fill='%235e7689' x='1049' y='899' width='151' height='151'/%3E%3Crect fill='%23617688' x='1049' y='749' width='151' height='151'/%3E%3Crect fill='%23637788' x='1049' y='600' width='151' height='150'/%3E%3Crect fill='%23667787' x='899' y='899' width='151' height='152'/%3E%3Crect fill='%2348515a' x='-1' y='149' width='152' height='152'/%3E%3Crect fill='%2349525c' x='150' y='150' width='150' height='151'/%3E%3Crect fill='%234a535d' x='-1' y='300' width='152' height='151'/%3E%3Crect fill='%234b545e' x='150' y='300' width='151' height='151'/%3E%3Crect fill='%234c565f' x='-1' y='450' width='152' height='151'/%3E%3Crect fill='%234d5761' x='-1' y='600' width='152' height='151'/%3E%3Crect fill='%234e5862' x='150' y='450' width='151' height='151'/%3E%3Crect fill='%234f5963' x='300' y='300' width='150' height='151'/%3E%3Crect fill='%23505a64' x='-1' y='750' width='152' height='151'/%3E%3Crect fill='%23515b66' x='150' y='600' width='151' height='151'/%3E%3Crect fill='%23515c67' x='300' y='450' width='151' height='151'/%3E%3Crect fill='%23525d68' x='-1' y='900' width='152' height='151'/%3E%3Crect fill='%23535e69' x='150' y='750' width='151' height='151'/%3E%3Crect fill='%2354606b' x='300' y='600' width='151' height='151'/%3E%3Crect fill='%2355616c' x='450' y='450' width='151' height='151'/%3E%3Crect fill='%2356626d' x='-1' y='1050' width='152' height='151'/%3E%3Crect fill='%2357636f' x='150' y='900' width='151' height='151'/%3E%3Crect fill='%23586470' x='300' y='750' width='151' height='151'/%3E%3Crect fill='%23596571' x='450' y='600' width='151' height='151'/%3E%3Crect fill='%235a6672' x='600' y='450' width='150' height='151'/%3E%3Crect fill='%235b6774' x='150' y='1050' width='151' height='151'/%3E%3Crect fill='%235c6875' x='300' y='1049' width='151' height='152'/%3E%3Crect fill='%235d6a76' x='300' y='900' width='151' height='150'/%3E%3Crect fill='%235e6b78' x='450' y='1049' width='151' height='152'/%3E%3Crect fill='%235f6c79' x='450' y='899' width='152' height='151'/%3E%3Crect fill='%23606d7a' x='450' y='750' width='152' height='150'/%3E%3Crect fill='%23616e7b' x='600' y='1049' width='151' height='152'/%3E%3Crect fill='%23626f7d' x='600' y='899' width='151' height='151'/%3E%3Crect fill='%2362707e' x='600' y='749' width='151' height='151'/%3E%3Crect fill='%2363717f' x='600' y='600' width='151' height='150'/%3E%3Crect fill='%23647281' x='750' y='1049' width='151' height='152'/%3E%3Crect fill='%23657482' x='750' y='899' width='150' height='151'/%3E%3Crect fill='%23667583' x='750' y='749' width='151' height='151'/%3E%3Crect fill='%23677684' x='750' y='600' width='150' height='150'/%3E%3Crect fill='%23687786' x='900' y='1050' width='150' height='151'/%3E%3Crect fill='%23475059' x='-1' y='-1' width='151' height='151'/%3E%3Crect fill='%23697887' x='900' y='750' width='150' height='150'/%3E%3Crect fill='%231a8182' x='1800' y='-1' width='151' height='151'/%3E%3Cg fill-opacity='0.79'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}
.incorrect-answer {
  margin-bottom: 5px;
}

</style>
  